export default __webpack_public_path__ + "static/media/page-not-found.e4f81f0c.png";